import React from 'react';
import Translate from 'react-translate-component';

const showChildren = (children, show) => children && (show || show === undefined);

export const DefinitionField = ({ translate, text, children, show, showAlways, textClassName }) => text || showChildren(children, show) || showAlways ? (
    <dl className="dl-horizontal">
        <Translate component="dt" content={translate} fallback={translate} />
        <dd className={textClassName}>
            { text }
            { children }
        </dd>
    </dl>
) : null;
